<template><div></div></template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { SHARED } from '@/utils/constants'

export default {
  computed: {
    ...mapGetters({
      onLine: 'network/onLine',
      isShared: 'utils/isShared',
    }),
  },
  watch: {
    onLine(v) {
      if (v) {
        this.updateStatus('backToOnLine')
      }
    },
    type(type) {
      if (type !== SHARED) {
        window.addEventListener('online', this.updateOnlineStatus)
        window.addEventListener('offline', this.updateOnlineStatus)
      } else {
        window.removeEventListener('online', this.updateOnlineStatus)
        window.removeEventListener('offline', this.updateOnlineStatus)
      }
    },
  },
  created() {
    if (!this.isShared) {
      this.setStatus(navigator.onLine)
    }
  },
  mounted() {
    if (!this.isShared) {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
    }
  },
  beforeDestroy() {
    if (!this.isShared) {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    }
  },
  methods: {
    ...mapMutations({
      setStatus: 'network/setStatus',
    }),
    ...mapActions({
      updateStatus: 'network/updateStatus',
    }),
    updateOnlineStatus(e) {
      // set onLine status in store
      const { type } = e
      this.setStatus(type === 'online')
    },
  },
}
</script>
